export default `
mutation sendCommand(
  $command: String!,
  $type: String!
){
  sendCommand(
    command: $command, type:$type
  )
}`
